/**
 * PANGEA ATLAS – ZENTRALE VIDEO-DATENBANK (POWERED BY GOOGLE FLOW / VEO 3.1)
 */
window.PANGEA_ATLAS_CATEGORIES = [
  {
    "id": "alle",
    "label": "Alle Videos",
    "icon": "🎬"
  },
  {
    "id": "Knoten & Montagen",
    "label": "Knoten & Montagen",
    "icon": "🪢"
  },
  {
    "id": "Tackle & Taktik",
    "label": "Tackle & Taktik",
    "icon": "🎯"
  },
  {
    "id": "Zander",
    "label": "Zander",
    "icon": "⚡"
  },
  {
    "id": "Hecht",
    "label": "Hecht",
    "icon": "🐊"
  },
  {
    "id": "Barsch",
    "label": "Barsch",
    "icon": "🔥"
  },
  {
    "id": "Karpfen",
    "label": "Karpfen",
    "icon": "🏕️"
  },
  {
    "id": "Wels",
    "label": "Wels",
    "icon": "⚓"
  },
  {
    "id": "Boote & Echolot",
    "label": "Boote & Echolot",
    "icon": "📡"
  }
];

window.PANGEA_ATLAS_PLAYLISTS = [
  {
    "id": "knoten-mastery",
    "tag": "PFLICHT-BASICS",
    "meta": "Lernpfad",
    "title": "Die wichtigsten Knoten & Rigs",
    "desc": "FG-Knoten, Clinch, Carolina-Rig & hechtsicheres Vorfach – in je 2 Minuten verinnerlicht.",
    "videoIds": []
  },
  {
    "id": "zander-crashkurs",
    "tag": "RAUBFISCH-FOKUS",
    "meta": "Lernpfad",
    "title": "Zander knacken am Fluss",
    "desc": "Faulenzer-Methode, Buhnenkessel lesen und die richtige Jigkopf-Grammatur.",
    "videoIds": []
  },
  {
    "id": "echolot-boot-pro",
    "tag": "MARINE & SONAR",
    "meta": "Lernpfad",
    "title": "Boot & Echolot Schnellstart",
    "desc": "Fischsicheln richtig deuten, SideVü-Strukturen lesen & Schlauchboot-Tuning.",
    "videoIds": []
  },
  {
    "id": "ansitz-riesen",
    "tag": "KARPFEN & WELS",
    "meta": "Lernpfad",
    "title": "Karpfen & Wels Montagen",
    "desc": "Hair-Rig, Futterplatz-Taktik, U-Posen-Montage und Abspannen auf Großwels.",
    "videoIds": []
  }
];

window.PANGEA_ATLAS_VIDEOS = [
  {
    "id": "verbesserter-clinch-vs-palomar-knoten-2-minuten",
    "title": "Verbesserter Clinch vs. Palomar-Knoten – Welcher Wirbelknoten behält über 90 % Tragkraft?",
    "category": "Knoten & Montagen",
    "level": "Einsteiger",
    "duration": "02:00",
    "durationSec": 120,
    "format": "16:9",
    "featured": true,
    "videoUrl": "https://cdn.shopify.com/s/files/1/0988/0813/6062/files/veo31_palomar_master.mp4?v=1793691668",
    "youtubeId": "",
    "vimeoId": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0988/0813/6062/files/veo31_palomar_thumb_5fc015f7-785b-4e9a-b341-a56685d955c4.jpg?v=1793691661",
    "summary": "In exakt 2 Minuten lernst du alles Wichtige zu „Verbesserter Clinch vs. Palomar-Knoten: Welcher Wirbelknoten behält über 90 % Tragkraft?“: Optimales Setup (0,12–0,16 mm 8-fach Geflochtene + 0,30–0,45 mm Fluorocarbon-Vorfach), Schritt-für-Schritt-Umsetzung für maximale lineare Knotentragkraft (über 90 %) und ruckfreies Gleiten durch kleine Micro-Guides und der entscheidende Profi-Kniff am Wasser.",
    "takeaways": [
      "Schnur-Setup vorbereiten: Für „Verbesserter Clinch vs. Palomar-Knoten“ die Hauptschnur auf Spannung halten und mindestens 25 cm Arbeitsende am Vorfach einplanen.",
      "Saubere Wicklungs-Geometrie: 12 bis 18 gleichmäßige Windungen ohne Überkreuzung legen, damit sich die Last unter Zug symmetrisch verteilt.",
      "Anfeuchten & Verriegeln: Knoten vor dem Zuziehen kräftig befeuchten (verhindert Reibungshitze), auf Zug prüfen und Überstand auf 2 mm kürzen."
    ],
    "proTip": "Ziehe den fertigen Knoten vor dem ersten Wurf immer mit zwei behandschuhten Händen kräftig auf Endspannung – erst wenn sich die Wicklungen dunkel verfärben, sitzt er 100 % rutschfest.",
    "chapters": [
      {
        "time": "00:00",
        "sec": 0,
        "label": "Prinzip & Setup: Verbesserter Clinch vs. Palomar-Knoten",
        "detail": "Warum Verbesserter Clinch vs. Palomar-Knoten den Unterschied macht – abgestimmt auf 0,12–0,16 mm 8-fach Geflochtene + 0,30–0,45 mm Fluorocarbon-Vorfach."
      },
      {
        "time": "00:30",
        "sec": 30,
        "label": "Schritt 1 & 2: Montage & Geometrie",
        "detail": "Schnur-Setup vorbereiten: Für „Verbesserter Clinch vs. Palomar-Knoten“ die Hauptschnur auf Spannung halten und mindestens 25 cm Arbeitsende am Vorfach einplanen. Danach: Saubere Wicklungs-Geometrie: 12 bis 18 gleichmäßige Windungen ohne Überkreuzung legen, damit sich die Last unter Zug symmetrisch verteilt."
      },
      {
        "time": "01:10",
        "sec": 70,
        "label": "Schritt 3: Führung & Bissverwertung",
        "detail": "Anfeuchten & Verriegeln: Knoten vor dem Zuziehen kräftig befeuchten (verhindert Reibungshitze), auf Zug prüfen und Überstand auf 2 mm kürzen."
      },
      {
        "time": "01:45",
        "sec": 105,
        "label": "Der Pangea Profi-Kniff",
        "detail": "Ziehe den fertigen Knoten vor dem ersten Wurf immer mit zwei behandschuhten Händen kräftig auf Endspannung – erst wenn sich die Wicklungen dunkel verfärben, sitzt er 100 % rutschfest."
      }
    ],
    "shopLinks": [
      {
        "title": "Raubfischangeln",
        "handle": "raubfischangeln"
      },
      {
        "title": "Handmade Zubehör (Vorfächer, Rigs etc.)",
        "handle": "handmade-zubehor-taschen-vorfacher-etc"
      }
    ],
    "compassTitle": "Clinch-Knoten: Der absolute Basis-Knoten für Wirbel",
    "compassUrl": "/blogs/compass/clinch-knoten-der-absolute-basis-knoten-fur-wirbel"
  }
];
